const demo_app = {
    notification: 'Wskazówka: Najpierw stwórz konto, aby przetestować proces logowania.',
};
export default Object.freeze(demo_app);
